/**
 * @ngdoc directive
 * @name stickyHeader
 * @module sharebase
 * @restrict A
 * @description
 *
 * `stickyHeader` clones the element and statically places it over the original element
 * @usage
 *
 * <table>
 *      <thead sb-sticky-header>
 *          <tr>
 *              <th>Column Name</th>
 *          </tr>
 *      </thead>
 * </table>
 *
 */
require('./stickyHeader.styles');
export function StickyHeaderDirective(
    $mdUtil,
    $timeout
):ng.IDirective {
    return {
        restrict: 'A',
        priority: 1,
        link: (scope:ng.IScope, element:ng.IAugmentedJQuery, attrs:ng.IAttributes) =>{
            if(element[0].nodeName.toLowerCase() !=='md-table-container'){
                throw new Error('sb-sticky-header directive must be used on a md-table-container element.');
            }
            
            // zero-length timeout forces the sticky header to execute on the next digest cycle,
            // allowing ng-repeat to generate the column headers on the DOM.
            $timeout(() => {
                let tableClone = element.find('table').clone();
                tableClone.find('tbody').remove();
                tableClone.find('thead').remove();

                let stickyTableElm = angular.element('<md-table-container class="sb-sticky-header app__background app--selction-disabled"></md-table-container>');
                stickyTableElm.append(tableClone);

                let insertTarget = $mdUtil.getClosest(element, 'md-virtual-repeat-container') ? angular.element($mdUtil.getClosest(element, 'md-virtual-repeat-container')) : element.parent();
                let scroller = $mdUtil.getClosest(element, 'md-virtual-repeat-container') ? angular.element(insertTarget[0].querySelector('.md-virtual-repeat-scroller')) : element.parent();

                insertTarget.parent().prepend(stickyTableElm);
                    
                let headerElm = element.find('thead');
                stickyTableElm.find('table').append(headerElm);


                scroller.on('scroll', function(){
                    if(this.scrollTop > 0){
                        stickyTableElm.addClass('md-whiteframe-2dp');
                        return;
                    }
                    stickyTableElm.removeClass('md-whiteframe-2dp');
                });
            }, 0);
        }
    };
}

StickyHeaderDirective.$inject = [
    '$mdUtil',
    '$timeout'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/stickyHeader/stickyHeader.ts